import * as React from "react"
import CommonFilters from "./index";


export default function CommonFiltersProductPage({ components={}, compProps={}, ...props }) {
    return <CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			favFiltersOnlyLine: true, skuGroup: true,
			...components
		}}
		compProps={{
			country: { filters: { websiteType: "2" } },
			site: { filters: { websiteType: "2" } },
			favFilters: { grid: { md: 3 } },
			...compProps
		}}
		{...props}
	/>
}